import {
  Text,
  GreyGrey60,
  Primary12Regular,
  SwitchLineField
} from '@sequencehq/core-components'
import { useState } from 'react'
import {
  useSelectPdfCoverImageSrc,
  useStorePdfCoverImageAsset
} from 'Cube/domain/subdomain/coverImage'
import { PdfCoverImagePreview } from './PdfCoverImagePreview'
import { COMMON_SWITCH_PROPS } from './QuoteSettingsInspectorItem'

export const PdfCoverImageSection = ({
  isDisabled
}: {
  isDisabled: boolean
}) => {
  const pdfCoverImageSrc = useSelectPdfCoverImageSrc()
  const storePdfCoverImageAsset = useStorePdfCoverImageAsset()
  const [showUpload, setShowUpload] = useState(false)
  const [shouldTriggerFilePicker, setShouldTriggerFilePicker] = useState(false)

  const hasPdfCoverImage = Boolean(pdfCoverImageSrc)
  const toggleValue = hasPdfCoverImage || showUpload
  const showPreview = hasPdfCoverImage || showUpload

  const handleToggle = (value: boolean) => {
    if (value) {
      setShowUpload(true)
      setShouldTriggerFilePicker(true)
    } else {
      setShowUpload(false)
      storePdfCoverImageAsset(null)
    }
  }

  return (
    <>
      <SwitchLineField
        data-testid="quote-inspector-settings-custom-pdf-cover-image"
        value={toggleValue}
        onChange={handleToggle}
        text="Custom PDF cover image"
        description={
          <Text {...Primary12Regular} color={GreyGrey60}>
            Minimum dimensions: 1224px x 586px
          </Text>
        }
        isDisabled={isDisabled}
        {...COMMON_SWITCH_PROPS}
      />
      {showPreview && (
        <PdfCoverImagePreview
          isDisabled={isDisabled}
          shouldTriggerFilePicker={shouldTriggerFilePicker}
          onFilePickerTriggered={() => setShouldTriggerFilePicker(false)}
          onFilePickerCancelled={() => setShowUpload(false)}
          onRemove={() => setShowUpload(false)}
        />
      )}
    </>
  )
}
